module.exports = __webpack_public_path__ + "static/img/02-02.5ea93ade.png";